import React, { useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { classNames } from "../../../helpers/classNames";
import { useDebounce } from "../../../hooks/useDebounce";
import Search from "../../../components/form/Search";
import LimitSelect from "../../../components/elements/LimitSelect";
import Button from "../../../components/form/Button";
import { handleFilterChange } from "../../../helpers";
import { toast } from "react-toastify";
import Table from "../../../components/elements/table/Table";
import dayjs from "dayjs";
import Badge from "../../../components/elements/Badge";
import DeleteModal from "../../../components/common/DeleteModal";
import useMutation from "../../../hooks/useMutation";
import {
  userDelete,
  userList,
  userStatusChange,
} from "../../../services/userService";
import StatusSelect from "../../../components/elements/StatusSelect";
import EmailVerified from "../../../components/elements/EmailVerified";
import Switch from "../../../components/form/Switch";
// import ManageUserModal from "./modal/ManageUserModal";
// import { userDelete, usersList } from "../../../services/userService";
// import StatusSelect from "../../../components/elements/StatusSelect";

function UserList({ isDashBoard = false }) {
  const [filters, setFilters] = useState({
    limit: 20,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: [filters, search],
    fetchFunction: async () => {
      const {
        roleCode = [],
        status = [],
        emailVerified = [],

        ...restFilters
      } = filters || {};

      const queryParams = {
        ...restFilters,
        ...(search && { keyword: search }),
        roleCode: "USER",
        ...Object.fromEntries(status.map((val, i) => [`status[${i}]`, val])),
        ...Object.fromEntries(
          emailVerified.map((val, i) => [`emailVerified[${i}]`, val])
        ),
      };

      const res = await userList(queryParams);
      console.log("UserList API response:", res);
      // return res?.docs?.data || [];
      // return Array.isArray(res?.docs?.data) ? res.docs.data : [];
      return res?.docs || [];
    },
  });
  //   user status change handler =================>
  // const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
  //   useMutation({
  //     mutationFn: async ({ id, status }) => {
  //       const res = await userStatusChange({
  //         ids: id,
  //         status,
  //       });
  //       return { res, payload: { id, status } };
  //     },
  //     onSuccess: ({ res, payload }) => {
  //       if (res?.status !== 200) {
  //         updateData((pre) => {
  //           pre.data = (pre?.data || [])?.map((elm) =>
  //             elm?._id === payload?.id
  //               ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
  //               : elm
  //           );
  //           return { ...pre };
  //         });
  //       }
  //       toast.success(res?.message);
  //       refetch();
  //     },
  //     onError: (error) => {
  //       console.log(error);
  //     },
  //   });
  //   user status and emailVerified change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
    useMutation({
      mutationFn: async ({ id, status, emailVerified }) => {
        const payload = {
          ids: id,
          ...(typeof status !== "undefined" && { status }),
          ...(typeof emailVerified !== "undefined" && { emailVerified }),
        };

        const res = await userStatusChange(payload);
        return { res, payload };
      },
      onSuccess: ({ res, payload }) => {
        if (res?.status !== 200) {
          updateData((pre) => {
            pre.data = (pre?.data || []).map((elm) => {
              if (elm?._id === payload?.ids) {
                return {
                  ...elm,
                  ...(payload.status && {
                    status: payload.status === 1 ? 2 : 1,
                  }),
                  ...(payload.featured && {
                    emailVerified: payload.emailVerified === 1 ? 2 : 1,
                  }),
                };
              }
              return elm;
            });
            return { ...pre };
          });
        }
      },
      onError: (error) => {
        console.error("Status change error:", error);
      },
    });

  const tableHeadData = [
    {
      _id: 1,
      name: "Name",
      align: "left",
    },
    {
      _id: 2,
      name: "Email",
      align: "left",
    },
    {
      _id: "cpf",
      name: "CPF",
      align: "left",
    },
    // {
    //   _id: "emailVerified",
    //   name: "Email Verified",
    //   align: "left",
    // },
    {
      _id: "emailVerified",
      name: "Email Verified",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            emailVerified: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.emailVerified;
            return { ...pre };
          });
        }
      },
      filterData: [
        { name: "Verified", value: 1, type: "checkbox" },
        { name: "Unverified", value: 2, type: "checkbox" },
      ],
    },
    // {
    //   _id: 3,
    //   name: "Phone",
    //   align: "left",
    // },
    {
      _id: 4,
      name: "Created date",
      align: "left",
    },

    {
      _id: "status",
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            status: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.status;
            return { ...pre };
          });
        }
      },
      filterData: [
        { name: "Active", value: 1, type: "checkbox" },
        { name: "Inactive", value: 2, type: "checkbox" },
      ],
    },
    // {
    //   _id: 5,
    //   name: "Action",
    //   align: "left",
    // },
  ];

  // const tableData = data?.map((item) => {
  //   return {
  //     _id: item?._id,
  //     rowData: [
  //       {
  //         _id: 1,
  //         type: "user",
  //         align: "left",
  //         cellClass: "!min-w-[100px]",
  //         data: item?.firstName + " " + item?.lastName || "-",
  //         image: item?.image?.url,
  //       },
  //       {
  //         _id: 2,
  //         type: "text",
  //         align: "left",
  //         cellClass: "!min-w-[100px]",
  //         data: item?.email || "-",
  //       },
  //       {
  //         _id: "cpf",
  //         type: "text",
  //         align: "left",
  //         cellClass: "!min-w-[100px]",
  //         data: item?.cpf || "-",
  //       },
  //       {
  //         _id: "emailVerified",
  //         type: "text",
  //         align: "left",
  //         cellClass: "!min-w-[100px]",
  //         data: (
  //           <Badge
  //             type={item?.emailVerified === 1 ? "success" : "danger"}
  //             label={item?.emailVerified === 1 ? "Verified" : "Unverified"}
  //             className={"!w-20"}
  //           />
  //         ),
  //       },
  //       // {
  //       //   _id: 3,
  //       //   type: "text",
  //       //   align: "left",
  //       //   cellClass: "!min-w-[100px]",
  //       //   data: item?.phone || "-",
  //       // },
  //       {
  //         _id: 4,
  //         type: "text",
  //         align: "left",
  //         cellClass: "!min-w-[100px]",
  //         data: dayjs(item?.createdAt).format("DD MMM, YYYY") || "-",
  //       },

  //       {
  //         _id: "status",
  //         type: "text",
  //         align: "left",
  //         cellClass: "!min-w-[100px]",
  //         data: (
  //           <div className="flex gap-2 items-center">
  //             <Switch
  //               className={
  //                 "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
  //               }
  //               checked={item?.status === 1}
  //               onChange={() => {
  //                 updateData((pre) => {
  //                   pre.data = (pre?.data || [])?.map((elm) =>
  //                     elm?._id === item?._id
  //                       ? { ...elm, status: elm?.status === 1 ? 2 : 1 }
  //                       : elm
  //                   );
  //                   return { ...pre };
  //                 });
  //                 statusChangeHandler({
  //                   id: item?._id,
  //                   status: item?.status === 1 ? 2 : 1,
  //                 });
  //               }}
  //             />
  //             <Badge
  //               type={item?.status === 1 ? "success" : "danger"}
  //               label={item?.status === 1 ? "Active" : "Inactive"}
  //               className={"!w-20"}
  //             />
  //           </div>
  //         ),
  //       },
  //       // {
  //       //   _id: 5,
  //       //   type: "action",
  //       //   align: "left",
  //       //   cellClass: "w-[5%]",
  //       //   actionData: [
  //       //     {
  //       //       _id: 1,
  //       //       name: "Edit",
  //       //       icon: "fa-regular fa-pen-to-square",
  //       //       onClick: () => {
  //       //         setModalOpen({ isOpen: true, data: item });
  //       //       },
  //       //       standout: false,
  //       //     },
  //       //     {
  //       //       _id: 3,
  //       //       name: "Delete",
  //       //       icon: "fa-regular fa-trash-can",
  //       //       standout: true,
  //       //       onClick: () => {
  //       //         setDeleteModal({
  //       //           isOpen: true,
  //       //           data: item,
  //       //         });
  //       //       },
  //       //     },
  //       //   ],
  //       // },
  //     ],
  //   };
  // });
  const tableData = Array.isArray(data?.data)
    ? data?.data.map((item) => {
        return {
          _id: item?._id,
          rowData: [
            {
              _id: 1,
              type: "user",
              align: "left",
              cellClass: "!min-w-[100px]",
              data:
                `${item?.firstName || ""} ${item?.lastName || ""}`.trim() ||
                "-",
              image: item?.image?.url,
            },
            {
              _id: 2,
              type: "text",
              align: "left",
              cellClass: "!min-w-[100px]",
              data: item?.email || "-",
            },
            {
              _id: "cpf",
              type: "text",
              align: "left",
              cellClass: "!min-w-[100px]",
              data: item?.cpf || "-",
            },
            {
              _id: "emailVerified",
              type: "text",
              align: "left",
              cellClass: "!min-w-[100px]",
              data: (
                <div className="flex gap-2 items-center">
                  <Switch
                    className={
                      "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                    }
                    checked={item?.emailVerified === 1}
                    onChange={() => {
                      updateData((pre) => {
                        pre.data = (pre?.data || []).map((elm) =>
                          elm?._id === item?._id
                            ? {
                                ...elm,
                                emailVerified: elm?.emailVerified === 1 ? 2 : 1,
                              }
                            : elm
                        );
                        return { ...pre };
                      });
                      statusChangeHandler({
                        id: item?._id,
                        emailVerified: item?.emailVerified === 1 ? 2 : 1,
                      });
                    }}
                  />
                  <Badge
                    type={item?.emailVerified === 1 ? "success" : "danger"}
                    label={
                      item?.emailVerified === 1 ? "Verified" : "Unverified"
                    }
                    className="!w-20"
                  />
                </div>
              ),
            },
            {
              _id: 4,
              type: "text",
              align: "left",
              cellClass: "!min-w-[100px]",
              data: dayjs(item?.createdAt).format("DD MMM, YYYY") || "-",
            },
            {
              _id: "status",
              type: "text",
              align: "left",
              cellClass: "!min-w-[100px]",
              data: (
                <div className="flex gap-2 items-center">
                  <Switch
                    className="!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                    checked={item?.status === 1}
                    onChange={() => {
                      updateData((pre) => {
                        pre.data = (pre?.data || []).map((elm) =>
                          elm?._id === item?._id
                            ? { ...elm, status: elm?.status === 1 ? 2 : 1 }
                            : elm
                        );
                        return { ...pre };
                      });
                      statusChangeHandler({
                        id: item?._id,
                        status: item?.status === 1 ? 2 : 1,
                      });
                    }}
                  />
                  <Badge
                    type={item?.status === 1 ? "success" : "danger"}
                    label={item?.status === 1 ? "Active" : "Inactive"}
                    className="!w-20"
                  />
                </div>
              ),
            },
          ],
        };
      })
    : [];

  function usersManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
          refetch();
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?.id === res?.data?.id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message);
    }
  }

  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await userDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?.id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });
  console.log(data?.metadata, "data?.metadata, data?.metadata?.totalDocs");
  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      {!isDashBoard && (
        <div className="space-y-8">
          <div className="font-bold text-center text-lg xl:text-3xl text-hobby">
            Users
          </div>
          <div className="flex items-center gap-3">
            <div className="w-36">
              <LimitSelect
                value={filters?.limit}
                allValue={data?.metadata?.totalDocs}
                onChange={(val) => handleFilterChange("limit", val, setFilters)}
              />
            </div>
            {/* <div className="w-36">
              <EmailVerified
                value={filters?.emailVerified}
                onChange={(val) =>
                  handleFilterChange("emailVerified", val, setFilters)
                }
              />
            </div> */}
            {/* <div className="w-36">
              <StatusSelect
                value={filters?.status}
                onChange={(val) =>
                  handleFilterChange("status", val, setFilters)
                }
              />
            </div> */}
            <div className="w-72">
              <Search
                placeholder={"Search here"}
                search={(val) => {
                  setKeyword(val);
                  handleFilterChange("page", 1, setFilters);
                }}
              />
            </div>
            {/* <div className="relative">
              <Button
                buttonClasses={
                  "!bg-transparent border border-transparent !h-10 hover:!bg-hobby/10 hover:!border-hobby/10"
                }
                buttonLabel={"Create New"}
                buttonLabelClasses={"font-medium !text-sm text-hobby"}
                buttonFunction={() =>
                  setModalOpen({ isOpen: true, data: null })
                }
              />
            </div> */}
          </div>
        </div>
      )}

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
        }}
        isOrderingDisabled={true}
      />
      {/* <ManageUserModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={usersManageResponse}
      /> */}
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?.id);
        }}
      />
    </div>
  );
}

export default UserList;
